let formObj;

export const setFormObject = (obj) => (formObj = obj);

export const getFormObject = () => formObj;
